import { COUNTRY_NOT_RECOGNIZED } from './constants';

const masks = {
    AC: {
        phone: '+247-####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AD: {
        phone: '+376-######',
        vat: '',
        postal: { regex: 'AD\\d{3}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AE: {
        phone: { regex: '\\+971\\-\\d{8,9}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AF: {
        phone: '+93-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AG: {
        phone: '+1268-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AI: {
        phone: '+1264-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AL: {
        phone: { regex: '\\+355\\-\\d{3,9}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '3',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AM: {
        phone: '+374-########',
        vat: '',
        postal: { regex: '(37)?\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AN: {
        phone: '+599-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AO: {
        phone: '+244-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AQ: {
        phone: '+672-1#####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AR: {
        phone: '+54-##########',
        vat: '',
        postal: { regex: '([A-HJ-NP-Z])?\\d{4}([A-Z]{3})?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AS: {
        phone: '+1684-#######',
        vat: '',
        postal: '96799',
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AT: {
        phone: { regex: '\\+43\\-\\d{4,13}', greedy: true },
        vat: {
            mask: 'ATU########',
        },
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '4',
            to: '13',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 8,
        },
    },
    AU: {
        phone: { regex: '\\+61\\-\\d{5,15}', greedy: true },
        vat: '',
        postal: { regex: '\\d{4}}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '15',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AW: {
        phone: '+297-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    AZ: {
        phone: { regex: '\\+994\\-\\d{8,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BA: {
        phone: '+387-########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BB: {
        phone: '+1246-#######',
        vat: '',
        postal: { regex: '(BB\\d{5})?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BD: {
        phone: '+880-########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BE: {
        phone: { regex: '\\+32\\-\\d{8,9}', greedy: true },
        vat: {
            mask: 'BE##########',
        },
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 10,
        },
    },
    BF: {
        phone: '+226-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BG: {
        phone: { regex: '\\+359\\-\\d{7,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BH: {
        phone: '+973-########',
        vat: '',
        postal: { regex: '((1[0-2]|[2-9])\\d{2})?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BI: {
        phone: '+257-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BJ: {
        phone: '+229-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BM: {
        phone: '+1441-#######',
        vat: '',
        postal: { regex: '[A-Z]{2}[ ]?[A-Z0-9]{2}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BN: {
        phone: '+673-#######',
        vat: '',
        postal: { regex: '[A-Z]{2}[ ]?\\d{4}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BO: {
        phone: '+591-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BR: {
        phone: '+55-##########',
        vat: '',
        postal: { regex: '\\d{5}[\\-]?\\d{3}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BS: {
        phone: '+1242-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BT: {
        phone: '+975-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BW: {
        phone: { regex: '\\+267\\-\\d{7,8}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BY: {
        phone: { regex: '\\+375\\-\\d{9,10}', greedy: true },
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '9',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    BZ: {
        phone: '+501-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CD: {
        phone: '+243-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CF: {
        phone: '+236-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CG: {
        phone: '+242-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CH: {
        phone: { regex: '\\+41\\-\\d{4,12}', greedy: true },
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '4',
            to: '12',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CI: {
        phone: '+225-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CK: {
        phone: '+682-#####',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CL: {
        phone: { regex: '\\+56\\-\\d{8,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{7}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CM: {
        phone: '+237-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CN: {
        phone: { regex: '\\+86\\-\\d{5,12}', greedy: true },
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '12',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CO: {
        phone: { mask: '+57-########[##]', greedy: false },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '8',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CR: {
        phone: '+506-########',
        vat: '',
        postal: { regex: '\\d{4,5}|\\d{3}-\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CU: {
        phone: '+53-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CV: {
        phone: '+238#######',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CW: {
        phone: '+599-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CY: {
        phone: { mask: '+357-########[###]', greedy: false },
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '8',
            to: '11',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CZ: {
        phone: { regex: '\\+420\\-\\d{4,12}', greedy: true },
        vat: {
            mask: 'CZ########[#][#]',
            greedy: false,
        },
        postal: { regex: '\\d{3}[ ]?\\d{2}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '4',
            to: '12',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_RANGE',
            digit: 8,
            digit1: 10,
        },
    },
    DE: {
        phone: { regex: '\\+49\\-\\d{6,13}', greedy: true, helper: 'Add from 6 to 13 digits' },
        vat: {
            mask: 'DE#########',
        },
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '6',
            to: '13',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 9,
        },
    },
    DJ: {
        phone: '+253-######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '6',
        },
    },
    DK: {
        phone: '+45-########',
        vat: { mask: 'DK########' },
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 8,
        },
    },
    DM: {
        phone: '+1767-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    DO: {
        phone: '+1-##########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    DZ: {
        phone: { mask: '+213-########[#]', greedy: false },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '8',
            to: '9',
        },
    },
    EC: {
        phone: '+593-########',
        vat: '',
        postal: { regex: '([A-Z]\\d{4}[A-Z]|(?:[A-Z]{2})?\\d{6})?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    EE: {
        phone: { regex: '\\+372\\-\\d{7,10}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    EG: {
        phone: { regex: '\\+20\\-\\d{7,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    ER: {
        phone: '+291-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    ES: {
        phone: '+34-#########',
        vat: {
            mask: 'ES=#######=',
        },
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_SPAIN_SPECIFIC',
        },
    },
    ET: {
        phone: '+251-#########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    FI: {
        phone: { regex: '\\+358\\-\\d{5,12}', greedy: true },
        vat: { mask: 'FI########' },
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '12',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 8,
        },
    },
    FJ: {
        phone: '+679-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    FK: {
        phone: '+500-#####',
        vat: '',
        postal: { regex: 'FIQQ 1ZZ' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    FM: {
        phone: '+691-#######',
        vat: '',
        postal: { mask: '9694#^#{4}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    FO: {
        phone: '+298-######',
        vat: '',
        postal: { regex: '\\d{3}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    FR: {
        phone: '+33-#########',
        vat: {
            mask: 'FR**#########',
        },
        postal: { regex: '\\d{2}[ ]?\\d{3}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_FRANCE_SPECIFIC',
        },
    },
    GA: {
        phone: { mask: '+241-######[#]', greedy: false },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '6',
            to: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GD: {
        phone: '+1473-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GE: {
        phone: '+995-#########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GF: {
        phone: '+594-#########',
        vat: '',
        postal: { regex: '9[78]3\\d{2}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GH: {
        phone: { regex: '\\+233\\-\\d{5,9}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GI: {
        phone: '+350-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GL: {
        phone: '+299-######',
        vat: '',
        postal: { regex: '39\\d{2}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GM: {
        phone: '+220-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GN: {
        phone: '+224-########',
        vat: '',
        postal: { regex: '\\d{3}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GQ: {
        phone: '+240-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GR: {
        phone: '+30-##########',
        vat: '',
        postal: { regex: '\\d{3}[ ]?\\d{2}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GT: {
        phone: '+502-########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GP: {
        phone: '+590-#########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GU: {
        phone: '+1671-#######',
        vat: '',
        postal: { regex: '969[123]\\d([ \\-]\\d{4})?' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GW: {
        phone: '+245-#######',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    GY: {
        phone: '+592-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    HK: {
        phone: { mask: '+852-####[####][#]', greedy: false },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE_BIG',
            from: '4',
            to: '8',
            secondTo: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    HN: {
        phone: '+504-########',
        vat: '',
        postal: { regex: '(?:\\d{5})?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    HR: {
        phone: { regex: '\\+385\\-\\d{8,12}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '12',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    HT: {
        phone: '+509-########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    HU: {
        phone: { regex: '\\+36\\-\\d{8,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    ID: {
        phone: { regex: '\\+62\\-\\d{5,10}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    IE: {
        phone: { regex: '\\+353\\-\\d{7,11}', greedy: true },
        vat: { mask: 'IE#*#####@[@]', greedy: false },
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '11',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_IRELAND_SPECIFIC',
        },
    },
    IL: {
        phone: { regex: '\\+972\\-\\d{8,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    IN: {
        phone: { regex: '\\+91\\-\\d{7,10}', greedy: true },
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    IO: {
        phone: '+246-#######',
        vat: '',
        postal: { regex: 'BBND 1ZZ' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    IQ: {
        phone: { regex: '\\+964\\-\\d{8,10}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    IR: {
        phone: '+98-##########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    IS: {
        phone: { mask: '+354-#######[##]', greedy: false },
        vat: '',
        postal: { regex: '\\d{3}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '7',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    IT: {
        phone: { regex: '\\+39\\-\\d{3,11}', greedy: true },
        vat: { mask: 'IT###########' },
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '3',
            to: '11',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 11,
        },
    },
    JM: {
        phone: '+1876-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    JO: {
        phone: { regex: '\\+962\\-\\d{5,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    JP: {
        phone: { regex: '\\+81\\-\\d{5,13}', greedy: true },
        vat: '',
        postal: { regex: '\\d{3}-\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '13',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    JA: {
        phone: { regex: '\\+81\\-\\d{5,13}', greedy: true },
        vat: '',
        postal: { regex: '\\d{3}-\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '13',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KE: {
        phone: { regex: '\\+254\\-\\d{6,10}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '6',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KG: {
        phone: '+996-#########',
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KH: {
        phone: '+855-########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KI: {
        phone: '+686-#####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KM: {
        phone: '+269-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KN: {
        phone: '+1869-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KP: {
        phone: '+850-#################',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KR: {
        phone: { regex: '\\+82\\-\\d{8,11}', greedy: true },
        vat: '',
        postal: { regex: '\\d{3}[\\-]\\d{3}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '11',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KW: {
        phone: { mask: '+965-#######[#]', greedy: false },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '7',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KY: {
        phone: '+1345-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    KZ: {
        phone: '+7-##########',
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    LA: {
        phone: '+856-########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    LB: {
        phone: { regex: '\\+961\\-\\d{7,8}', greedy: true },
        vat: '',
        postal: { regex: '(\\d{4}([ ]?\\d{4})?)?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    LC: {
        phone: '+1758-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    LI: {
        phone: '+423-##########',
        vat: '',
        postal: { regex: '(948[5-9])|(949[0-7])' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    LK: {
        phone: '+94-#########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    LR: {
        phone: { regex: '\\+231\\-\\d{7,8}', greedy: true },
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    LS: {
        phone: '+266-########',
        vat: '',
        postal: { regex: '\\d{3}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    LT: {
        phone: '+370-########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    LU: {
        phone: { regex: '\\+352\\-\\d{4,11}', greedy: true },
        vat: { mask: 'LU########' },
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '4',
            to: '11',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 8,
        },
    },
    LV: {
        phone: { mask: '+371-#######[#]', greedy: false },
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '7',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    LY: {
        phone: { regex: '\\+218\\-\\d{8,9}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MA: {
        phone: '+212-#########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MC: {
        phone: '+377-########',
        vat: '',
        postal: { regex: '980\\d{2}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MD: {
        phone: '+373-########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    ME: {
        phone: { regex: '\\+382\\-\\d{4,12}', greedy: true },
        vat: '',
        postal: { regex: '8\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '4',
            to: '12',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MG: {
        phone: { regex: '\\+261\\-\\d{9,10}', greedy: true },
        vat: '',
        postal: { regex: '\\d{3}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '9',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MH: {
        phone: '+692-#######',
        vat: '',
        postal: { regex: '969[67]\\d([ \\-]\\d{4})?' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MK: {
        phone: '+389-########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    ML: {
        phone: '+223-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MM: {
        phone: { regex: '\\+95\\-\\d{7,9}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '9',
        },
    },
    MN: {
        phone: { regex: '\\+976\\-\\d{7,8}', greedy: true },
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MO: {
        phone: '+853-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MP: {
        phone: '+1-670-###-####',
        vat: '',
        postal: { regex: '9695[012]([ \\-]\\d{4})?' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MQ: {
        phone: '+596-#########',
        vat: '',
        postal: { regex: '9[78]2\\d{2}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MR: {
        phone: '+222-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MS: {
        phone: '+1-664-###-####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MT: {
        phone: '+356-########',
        vat: '',
        postal: { regex: '[A-Z]{3}[ ]?\\d{2,4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MU: {
        phone: '+230-#######',
        vat: '',
        postal: { regex: '(\\d{3}[A-Z]{2}\\d{3})?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MV: {
        phone: '+960-#######',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MW: {
        phone: { mask: '+265-#######[#]', greedy: false },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '7',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MX: {
        phone: {
            mask: '+52-##########',
        },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MY: {
        phone: { regex: '\\+60\\-\\d{7,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MZ: {
        phone: { regex: '\\+258\\-\\d{8,9}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    NA: {
        phone: { regex: '\\+264\\-\\d{6,10}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '6',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    NC: {
        phone: '+687-######',
        vat: '',
        postal: { regex: '988\\d{2}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    NE: {
        phone: '+227-########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    NF: {
        phone: '+672-3#####',
        vat: '',
        postal: { regex: '2899' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    NG: {
        phone: { regex: '\\+234\\-\\d{7,10}', greedy: true },
        vat: '',
        postal: { regex: '(\\d{6})?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    NI: {
        phone: '+505-########',
        vat: '',
        postal: { regex: '((\\d{4}-)?\\d{3}-\\d{3}(-\\d{1})?)?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    NL: {
        phone: '+31-#########',
        vat: { mask: 'NL#########B##' },
        postal: { regex: '\\d{4}[ ]?[A-Z]{2}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 11,
        },
    },
    NO: {
        phone: { mask: '+47-#####[###]', greedy: false },
        vat: {
            mask: 'NO#########MVA',
        },
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '5',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 9,
        },
    },
    DEEE: {
        phone: { regex: '\\+49\\-\\d{6,13}', greedy: false, helper: 'Add from 6 to 13 digits' },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    // NO2: {
    // 	phone: { mask: '+47-#[#]-######[#]', greedy: false },
    // 	vat: '',
    // 	postal:  {regex: ""},
    // 	show: true,
    // },
    // NO: {
    // 	phone: { regex: '\\+47\\-(2\\-\\d{7}|\\d{2}-\\d{6})', greedy: false },
    // 	vat: '',
    // 	postal:  {regex: ""},
    // 	show: true,
    // },
    NP: {
        phone: '+977-########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    NR: {
        phone: '+674-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    NU: {
        phone: '+683-####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    NZ: {
        phone: { regex: '\\+64\\-\\d{3,10}', greedy: true },
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '3',
            to: '10',
        },
    },
    OM: {
        phone: { regex: '\\+968\\-\\d{7,8}', greedy: true },
        vat: '',
        postal: { regex: '(PC )?\\d{3}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    PA: {
        phone: { mask: '+507-#######[8]', greedy: false },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '7',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    PE: {
        phone: { regex: '\\+51\\-\\d{8,11}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '11',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    PF: {
        phone: '+689-######',
        vat: '',
        postal: { regex: '987\\d{2}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    PG: {
        phone: '+675-########',
        vat: '',
        postal: { regex: '\\d{3}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    PH: {
        phone: { regex: '\\+63\\-\\d{8,10}', greedy: true },
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    PK: {
        phone: { regex: '\\+92\\-\\d{8,11}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '11',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    PL: {
        phone: { regex: '\\+48\\-\\d{6,9}', greedy: true },
        vat: {
            mask: 'PL##########',
        },
        postal: { regex: '\\d{2}-\\d{3}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '6',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 10,
        },
    },
    PS: {
        phone: '+970-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    PT: {
        phone: { mask: '+351-#########[##]', greedy: false },
        vat: {
            mask: 'PT#########',
        },
        postal: { regex: '\\d{4}([\\-]\\d{3})?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '9',
            to: '11',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 9,
        },
    },
    PW: {
        phone: '+680-#######',
        vat: '',
        postal: { regex: '96940' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    PY: {
        phone: { regex: '\\+595\\-\\d{5,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    PR: {
        phone: '+1-##########',
        vat: '',
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
    },
    QA: {
        phone: { regex: '\\+974\\-\\d{3,8}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '3',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    YT: {
        phone: '+262-#########',
        vat: '',
        postal: { regex: '9[78]4\\d{2}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    RE: {
        phone: '+262-#########',
        vat: '',
        postal: { regex: '9[78]4\\d{2}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    RO: {
        phone: '+40-#########',
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    RS: {
        phone: { regex: '\\+381\\-\\d{4,12}', greedy: true },
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '4',
            to: '12',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    CS: {
        phone: { regex: '\\+381\\-\\d{4,12}', greedy: true },
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '4',
            to: '12',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    RU: {
        phone: '+7-##########',
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    RW: {
        phone: '+250-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
    },
    SA: {
        phone: { regex: '\\+966\\-\\d{8,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SB: {
        phone: '+677-#####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SC: {
        phone: '+248-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SD: {
        phone: '+249-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SE: {
        phone: { regex: '\\+46\\-\\d{7,13}', greedy: false },
        vat: {
            mask: 'SE############',
        },
        postal: { regex: '\\d{3}[ ]?\\d{2}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '13',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 12,
        },
    },
    SG: {
        phone: { regex: '\\+65\\-\\d{8,12}', greedy: true },
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '12',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SH: {
        phone: '+290-####',
        vat: '',
        postal: { regex: '(ASCN|STHL) 1ZZ' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SI: {
        phone: '+386-########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SK: {
        phone: { regex: '\\+421\\-\\d{4,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{3}[ ]?\\d{2}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '4',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SL: {
        phone: '+232-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SM: {
        phone: '+378-##########',
        vat: '',
        postal: { regex: '4789\\d' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SN: {
        phone: '+221-#########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SO: {
        phone: { regex: '\\+252\\-\\d{5,8}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SR: {
        phone: { regex: '\\+597\\-\\d{6,7}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '6',
            to: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SS: {
        phone: '+211-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    ST: {
        phone: '+239-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SV: {
        phone: { mask: '+503-#######[#][###]', greedy: false },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE_BIG',
            from: '7',
            to: '8',
            secondTo: '11',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    SX: { phone: '+1-721-###-####', vat: '', postal: { regex: '' }, show: true },
    SY: {
        phone: { regex: '\\+963\\-\\d{8,10}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '10',
        },
    },
    SZ: {
        phone: '+268-########',
        vat: '',
        postal: { regex: '[HLMS]\\d{3}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TC: {
        phone: '+1649-#######',
        vat: '',
        postal: { regex: 'TKCA 1ZZ' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TD: {
        phone: '+235-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TG: {
        phone: '+228-########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TH: {
        phone: { mask: '+66-########[#]', greedy: false },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_STRICT',
            from: '8',
            to: '9',
        },
    },
    TJ: {
        phone: '+992-#########',
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TK: {
        phone: '+690-####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TL: {
        phone: '+670-78######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TM: {
        phone: '+993-########',
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TN: {
        phone: '+216-########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '8',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TO: {
        phone: '+676-#####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TR: {
        phone: '+90-##########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TT: {
        phone: '+1868-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TV: {
        phone: '+688-2####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TW: {
        phone: { regex: '\\+886\\-\\d{8,9}', greedy: true },
        vat: '',
        postal: { regex: '\\d{3}(\\d{2})?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '8',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    TZ: {
        phone: '+255-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    UA: {
        phone: '+380-#########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    UG: {
        phone: '+256-#########',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    UK: {
        phone: { regex: '\\+44\\-\\d{7,10}', greedy: true },
        vat_standard: {
            mask: 'GB### #### ##',
        },
        vat_branchTraders: {
            mask: 'GB### #### ## ###',
        },
        vat_gd: {
            mask: 'GBGD###',
        },
        vat_ha: {
            mask: 'GBHA###',
        },
        postal: {
            regex:
                'GIR\\s?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\\d[\\dA-Z]?\\s?\\d[ABD-HJLN-UW-Z]{2}))|BFPO\\s?\\d{1,4}',
        },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '10',
        },
        validationVatCfg_standard: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 9,
        },
        validationVatCfg_branchTraders: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 12,
        },
        validationVatCfg_gd: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 3,
        },
        validationVatCfg_ha: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 3,
        },
    },
    GB: {
        phone: { regex: '\\+44\\-\\d{7,10}', greedy: true },
        vat_standard: {
            mask: 'GB### #### ##',
        },
        vat_branchTraders: {
            mask: 'GB### #### ## ###',
        },
        vat_gd: {
            mask: 'GBGD###',
        },
        vat_ha: {
            mask: 'GBHA###',
        },
        postal: {
            regex:
                'GIR\\s?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\\d[\\dA-Z]?\\s?\\d[ABD-HJLN-UW-Z]{2}))|BFPO\\s?\\d{1,4}',
        },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '10',
        },
        validationVatCfg_standard: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 9,
        },
        validationVatCfg_branchTraders: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 12,
        },
        validationVatCfg_gd: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 3,
        },
        validationVatCfg_ha: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 3,
        },
    },
    UY: {
        phone: { regex: '\\+598\\-\\d{4,11}', greedy: true },
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '4',
            to: '11',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    UZ: {
        phone: '+998-#########',
        vat: '',
        postal: { regex: '\\d{6}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    VA: {
        phone: '+39-6698#####',
        vat: '',
        postal: { regex: '00120' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    VC: {
        phone: '+1784-#######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    VE: {
        phone: '+58-##########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    VG: {
        phone: '+1-284-###-####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    VI: {
        phone: '+1340-#######',
        vat: '',
        postal: { regex: '008(([0-4]\\d)|(5[01]))([ \\-]\\d{4})?' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '7',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    VN: {
        phone: { regex: '\\+84\\-\\d{7,10}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '7',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    VU: {
        phone: '+678-#####',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    WF: {
        phone: '+681-######',
        vat: '',
        postal: { regex: '986\\d{2}' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    WS: {
        phone: '+685-######',
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    YE: {
        phone: { regex: '\\+967\\-\\d{6,9}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '6',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    ZA: {
        phone: '+27-#########',
        vat: '',
        postal: { regex: '\\d{4}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    ZM: {
        phone: '+260-#########',
        vat: '',
        postal: { regex: '\\d{5}' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    // ZW: { phone: '+263-#-######', vat: '', postal:  {regex: ""} },
    ZW: {
        phone: { regex: '\\+263\\-\\d{5,10}', greedy: true },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_RANGE',
            from: '5',
            to: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    MALTA: {
        phone: { mask: '+47-#####[###]', greedy: false, helper: 'Add 5- or 8-digit number' },
        vat: '',
        postal: { regex: '' },
        show: true,
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    US: {
        phone: {
            mask: '+1-###-###-####',
            helper: 'Add 10-digit number',
        },
        vat: {
            mask: 'TEST######',
        },
        postal: {
            greedy: false,
            mask: '#####[-####]',
        },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationPostalCfg: {
            phraseCode: 'MASK_STRICT',
            from: '5',
            to: '9',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_DIGIT_LENGTH_POSTFIX',
            digit: 5,
        },
    },
    CA: {
        phone: '+1-###-###-####',
        vat: '',
        postal: { regex: '[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d' },
        show: true,
        validationPhoneCfg: {
            phraseCode: 'MASK_SIMPLE',
            from: '10',
        },
        validationVatCfg: {
            phraseCode: 'MASK_VAT_ID_FORMAT',
        },
    },
    [COUNTRY_NOT_RECOGNIZED]: {
        phone: {},
        postal: {},
    },
};

export default masks;
